const HIDDEN_MODULES_KEY = 'HiddenModules';

export const Modules = {
  DEVICES: 'DEVICES',
  LOGIC_EDITOR: 'LOGIC_EDITOR',
  DIAGNOSE: 'DIAGNOSE',
  BATCH: 'BATCH',
  MIXES: 'MIXES',
  MATERIALS: 'MATERIALS',
  TICKETS: 'TICKETS',
  DISCHARGE: 'DISCHARGE',
  SETTINGS: 'SETTINGS',
  TEST_MODE: 'TEST_MODE',
  FIRMWARE: 'FIRMWARE',
  DYNAMIC_FREE_FALL: 'DYNAMIC_FREE_FALL',
} as const;

export type Module = typeof Modules[keyof typeof Modules];

const hiddenModules: Module[] = [
  Modules.LOGIC_EDITOR,
  Modules.FIRMWARE,
  Modules.DYNAMIC_FREE_FALL,
];

export const isModuleVisible = (module: Module): boolean => {
  const hidden: Module[] = JSON.parse(
    localStorage.getItem(HIDDEN_MODULES_KEY) ?? '[]',
  );

  return !hidden.includes(module);
};

export const hideModules = (modules: Module[] = []): void => {
  localStorage.setItem(HIDDEN_MODULES_KEY, JSON.stringify(modules));
};

hideModules(hiddenModules);

// @ts-ignore
window.Modules = Object.keys(Modules);
// @ts-ignore
window.hiddenModules = hiddenModules;
// @ts-ignore
window.hideModules = hideModules;
